import script from "./MainDarkBarTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainDarkBarTop.vue?vue&type=script&lang=ts&setup=true"

import "./MainDarkBarTop.vue?vue&type=style&index=0&id=1cc0049c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc0049c"]])

export default __exports__